









































import Vue from 'vue';
import ContainItemEditor from './ContainItemEditor.vue';

enum Op {
  LT = 'LT',
  GT = 'GT',
  EQ = 'EQ',
  IN = 'IN',
  NOT_IN = 'NOT_IN'
}

export default Vue.extend({
  components: {
    ContainItemEditor,
  },
  data() {
    return {
      op: Op.GT,
      showValuesPanel: false,
    };
  },
  props: {
    custom: Object,
  },
  beforeMount() {
    if (this.custom.nums && this.custom.nums.length) {
      this.op = this.custom.notIn ? Op.NOT_IN : Op.IN;
    } else {
      switch (this.custom.greater) {
        case 1:
          this.op = Op.GT;
          break;
        case 0:
          this.op = Op.EQ;
          break;
        case -1:
          this.op = Op.LT;
          break;
      }
    }
  },
  methods: {
    updateOp(op: string): void {
      this.op = Op[(op as keyof typeof Op)];
      switch (op) {
        case Op.GT:
          this.$emit('updateGreater', 1);
          break;
        case Op.EQ:
          this.$emit('updateGreater', 0);
          break;
        case Op.LT:
          this.$emit('updateGreater', -1);
          break;
        case Op.IN:
          this.$emit('updateNotIn', false);
          break;
        case Op.NOT_IN:
          this.$emit('updateNotIn', true);
          break;
      }
    },
    updateNums(nums: string[]) {
      const parsed = nums.map((it) => Number(it));
      this.$emit('updateNums', parsed);
      this.$emit('updateNum', null);
      this.showValuesPanel = false;
    },
    updateNum(num: number) {
      this.$emit('updateNum', num);
      this.$emit('updateNums', null);
    },
  },
});
